import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {WidgetInstance} from 'friendly-challenge';
import {useIntl} from 'react-intl';
import * as Sentry from '@sentry/react';


import * as i18nUtils from '../../../../utils/i18nUtils';

import config from '../../../../config';

import styles from './Captcha.scss';


function Captcha({doResetOnError, onError, onStart, onSuccess}) {

    const {locale} = useIntl();

    // nothing configured
    if (!config.captcha.siteKey) {

        // defer to avoid bad-state
        useEffect(() => onSuccess('empty'), ['nothing']);

        return null;
    }

    const containerRef = useRef();

    /** @type {object} */
    const widgetRef = useRef();

    // initialize depending on container and existence
    useEffect(() => {

        if (widgetRef.current || !containerRef.current) {

            return;
        }

        widgetRef.current = new WidgetInstance(containerRef.current, {
            doneCallback: onSuccess,
            errorCallback: error => {

                Sentry.captureException(new Error('Error during captcha: ' + error));
                if (doResetOnError) {
                    widgetRef.current.reset();
                }
                if (onError) {
                    onError();
                }
            },
            language: i18nUtils.getBaseLocaleTag(locale),
            sitekey: config.captcha.siteKey,
            startMode: 'auto',
            startedCallback: onStart
        });

        return () => {

            if (widgetRef.current) {
                widgetRef.current.destroy();
            }
        };

    }, [containerRef]);

    return (
        <div
            className={styles.captchaWrap}
            ref={containerRef}
        />
    );
}


Captcha.propTypes = {
    doResetOnError: PropTypes.bool,
    onError: PropTypes.func,
    onStart: PropTypes.func,
    onSuccess: PropTypes.func
};


Captcha.defaultProps = {
    doResetOnError: true
};


export default Captcha;
